var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{scopedSlots:_vm._u([{key:"menu-drawer",fn:function(){return [_c('admin-menu')]},proxy:true}])},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }